import { Box, Checkbox, FormControlLabel } from '@mui/material';
import { Square } from '@mui/icons-material';
import { Requirement } from '../../@types/requirements';

type DayCheckboxControlProps = {
    requirements: Requirement[];
    selectedRequirementID: number | undefined;
    onChange: (checked: boolean, requirement: Requirement) => void;
};

const DayCheckboxControl = ({ requirements, selectedRequirementID, onChange }: DayCheckboxControlProps) => {
    const selectedRequirement = requirements.find(req => req.ID === selectedRequirementID) || requirements[0];

    return (
        <Box
            sx={{
                position: 'absolute',
                top: 16,
                right: 60,
                width: 'fit-content',
                height: 'fit-content',
                backgroundColor: '#e0e0e0',
                zIndex: 1000,
                paddingTop: 2,
                padding: '4px 8px',
                borderRadius: 20,
            }}>
            {requirements.map(r => {
                const dueAt = new Date(Date.parse(r.DueAt));
                const day = dueAt.toLocaleDateString('hu-HU', { weekday: 'short' });
                return (
                    <FormControlLabel
                        key={day}
                        label={<strong>{day}</strong>}
                        labelPlacement='top'
                        sx={{
                            padding: 0,
                            margin: 0,
                            marginTop: '4px',
                            '.MuiFormControlLabel-label': {
                                fontSize: 8,
                                marginBottom: '-17px',
                                zIndex: '100',
                            },
                        }}
                        control={
                            <Checkbox
                                checked={selectedRequirement.ID === r.ID}
                                color={selectedRequirement.ID === r.ID ? 'success' : undefined}
                                checkedIcon={<Square />}
                                onChange={e => onChange(e.target.checked, r)}
                                name={day}
                                size='medium'
                                sx={{ padding: 0 }}
                            />
                        }
                    />
                );
            })}
        </Box>
    );
};

export default DayCheckboxControl;